import { Tabs as LYTabs, TabsProps, TabType } from '@lyearn/ui';
import { Link } from '@/components/Link';

export default function Tabs<T extends string>(props: TabsProps<T>) {
  const { LinkComponent = Link, ...rest } = props;
  return <LYTabs LinkComponent={LinkComponent} {...rest} />;
}

export type { TabsProps, TabType };
